import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

const moduleVesselEquipmentStatus = {
  namespaced: true,

  state: {
    name: 'vessel-equipment-status',
    equipmentStatuses: [],
    statuses: [],
    statusesMap: {}
  },

  mutations,
  getters,
  actions
}

export default moduleVesselEquipmentStatus;